import { ReactNode, useCallback, useReducer } from 'react';
import LeaderboardContext from './leaderboardContext';
import leaderboardReducer from './leaderboardReducer';
import { LeaderboardTypes, SortDirection, SortKey } from './leaderboardTypes';

type LeaderboardStateProps = {
    children: ReactNode;
};

const LeaderboardState: React.FC<LeaderboardStateProps> = ({ children }) => {
    const setSort = useCallback(
        (key: SortKey) =>
            dispatch({
                type: 'SET_SORT',
                payload: key,
            }),
        []
    );

    const initialState: LeaderboardTypes = {
        activeSort: {
            direction: SortDirection.DESC,
            sortKey: 'realizedPnL',
        },
        setSort,
    };

    const [state, dispatch] = useReducer(leaderboardReducer, initialState);

    return (
        <LeaderboardContext.Provider
            value={{
                activeSort: state.activeSort,
                setSort,
            }}
        >
            {children}
        </LeaderboardContext.Provider>
    );
};

export default LeaderboardState;
